module.exports = __webpack_public_path__ + "static/cloud-4-88a39ef5a56e6b5a30a8015789f3f459.png";